/**
 * Success Screen Component
 *
 * Shown after successful submission.
 */

// Checkmark icon
const CheckIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

interface SuccessScreenProps {
  requirementId: string;
  onClose: () => void;
}

export function SuccessScreen({ requirementId, onClose }: SuccessScreenProps) {
  return (
    <div className="psc-success" data-testid="psc-success-screen">
      <div className="psc-success__icon">
        <CheckIcon />
      </div>
      <h3 className="psc-success__title">Submitted Successfully!</h3>
      <p className="psc-success__message">
        Thank you for your feedback. Your submission has been received and will be reviewed by our
        team.
      </p>
      <div className="psc-success__id">
        <span className="psc-success__id-label">Reference ID:</span>
        <code className="psc-success__id-value">{requirementId}</code>
      </div>
      <p className="psc-success__note">
        Save this ID if you need to follow up on your submission.
      </p>
      <button
        onClick={onClose}
        className="psc-button psc-button--primary psc-success__button"
        data-testid="psc-close-button"
      >
        Close
      </button>
    </div>
  );
}
